import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Shared hook that fetches public (active) banners once.
 * Used by both BannerCarousel and the Home hero so the hero can
 * collapse its top padding when a banner is present.
 */
export default function usePublicBanners() {
  const [banners, setBanners] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    api
      .get("/banners")
      .then((res) => {
        if (!alive) return;
        setBanners(res.data || []);
        setLoaded(true);
      })
      .catch(() => alive && setLoaded(true));
    return () => {
      alive = false;
    };
  }, []);

  return { banners, loaded, hasBanner: loaded && banners.length > 0 };
}
